import api from "../services/api";
import { APIS } from "../endpoints";

/**
 * This function return songs data
 * @returns {Promise<Object>} - Function return Songs data
 */

export const getInstitutionData = async (
  limit,
  page,
  searchTerm,
  filterOptions = {},
) => {
  const response = await getInstitutionAPIData(
    limit,
    page,
    searchTerm,
    filterOptions,
  );
  return response;
};

const _isDefaultFilterOptions = (opts) => {
  if (!opts || typeof opts !== "object") return true;
  const filters = opts.filters;
  const hasFilterValues =
    filters &&
    typeof filters === "object" &&
    Object.values(filters).some((v) =>
      Array.isArray(v) ? v.length > 0 : Boolean(v),
    );
  if (hasFilterValues) return false;
  if (opts.search) return false;
  return true;
};

export const getInstitutionAPIData = async (
  limit,
  page,
  searchTerm,
  filterOptions = {},
) => {
  const formData = new FormData();
  formData.append("page", page);
  formData.append("limit", limit);

  if (!_isDefaultFilterOptions(filterOptions)) {
    const cleanedOptions = {
      ...filterOptions,
      filters: Object.fromEntries(
        Object.entries(filterOptions.filters || {}).filter(([, v]) =>
          Array.isArray(v) ? v.length > 0 : Boolean(v),
        ),
      ),
    };
    formData.append("filters", JSON.stringify(cleanedOptions));
  }

  if (searchTerm) {
    formData.append("search", searchTerm);
  }

  if (filterOptions.sortBy_v) {
    formData.append("sort_by", filterOptions.sortBy_v);
  }

  if (filterOptions.sortOrder_v) {
    formData.append("sort_order", filterOptions.sortOrder_v);
  }

  const params = new URLSearchParams(formData);

  const result = await api.get(`${APIS.BASE_URL}${APIS.adminInstitution}`, {
    params: params,
  });
  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const getInstitutionBasicData = async (alias) => {
  const result = await api.get(
    `${APIS.BASE_URL}admin/institution/${alias}/general/basic`,
  );
  if (result) {
    return result?.data?.data || {};
  } else {
    return {};
  }
};

export const updateInstitutionBasicData = async (
  alias,
  data,
  deletedValues,
) => {
  const payload = {
    ...data,
    deletedValues: deletedValues,
  };

  const result = await api.put(
    `${APIS.BASE_URL}admin/institution/${alias}/general/basic`,
    payload,
  );

  if (result) {
    return result?.data;
  } else {
    return {};
  }
};

export const getInstitutionPrefaceData = async (alias) => {
  const result = await api.get(
    `${APIS.BASE_URL}admin/institution/${alias}/introduction/preface`,
  );
  if (result) {
    return result?.data?.data;
  } else {
    return [];
  }
};

export const updateInstitutionPrefaceData = async (
  alias,
  data,
  deletedValues,
) => {
  const payload = {
    ...data,
    deletedValues: deletedValues,
  };
  const result = await api.put(
    `${APIS.BASE_URL}admin/institution/${alias}/introduction/preface`,
    payload,
  );
  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const getInstitutionEstablishmentData = async (alias) => {
  const result = await api.get(
    `${APIS.BASE_URL}admin/institution/${alias}/introduction/establishment`,
  );
  if (result) {
    return result?.data?.data;
  } else {
    return [];
  }
};

export const updateInstitutionEstablishmentData = async (
  alias,
  data,
  deletedValues,
) => {
  const payload = {
    ...data,
    deletedValues: deletedValues,
  };
  const result = await api.put(
    `${APIS.BASE_URL}admin/institution/${alias}/introduction/establishment`,
    payload,
  );
  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const getInstitutionTeamData = async (alias) => {
  const result = await api.get(
    `${APIS.BASE_URL}admin/institution/${alias}/introduction/team`,
  );
  if (result) {
    return result?.data?.data;
  } else {
    return [];
  }
};

export const updateInstitutionTeamData = async (alias, data, deletedValues) => {
  const payload = {
    ...data,
    deletedValues: deletedValues,
  };
  const result = await api.put(
    `${APIS.BASE_URL}admin/institution/${alias}/introduction/team`,
    payload,
  );
  if (result) {
    return result?.data;
  } else {
    return [];
  }
};
